/**
 * Функция для получения имени пользователя из Telegram Web App API
 *
 * Приоритет получения информации:
 * 1. username (с символом @)
 * 2. имя + фамилия
 * 3. только имя
 * 4. ID пользователя (с префиксом "User")
 * 5. "Anonym" если ничего не доступно
 *
 * Также проверяет альтернативные пути получения данных:
 * - window.Telegram.WebApp.initDataUnsafe.user
 * - window.Telegram.WebApp.initData (если нужно парсить)
 *
 * @returns {string} Имя пользователя или fallback значение
 */
export const getTelegramUserName = (): string => {
  // Проверяем, доступен ли Telegram Web App API
  if (typeof window !== 'undefined' && window.Telegram?.WebApp) {
    // Попытка 1: получить данные через initDataUnsafe
    if (window.Telegram.WebApp.initDataUnsafe?.user) {
      const user = window.Telegram.WebApp.initDataUnsafe.user;

      // Приоритет 1: username (если есть)
      if (user.username) {
        return `${user.username}`;
      }

      // Приоритет 2: имя + фамилия
      if (user.first_name && user.last_name) {
        return `${user.first_name} ${user.last_name}`;
      }

      // Приоритет 3: только имя
      if (user.first_name) {
        return user.first_name;
      }

      // Приоритет 4: ID пользователя
      if (user.id) {
        return `User ${user.id}`;
      }
    }

    // Попытка 2: получить данные через initData (если initDataUnsafe не работает)
    if (window.Telegram.WebApp.initData) {
      try {
        // Пытаемся парсить initData
        const urlParams = new URLSearchParams(window.Telegram.WebApp.initData);
        const userParam = urlParams.get('user');

        if (userParam) {
          const userData = JSON.parse(decodeURIComponent(userParam));

          if (userData.username) {
            return `@${userData.username}`;
          }
          if (userData.first_name && userData.last_name) {
            return `${userData.first_name} ${userData.last_name}`;
          }
          if (userData.first_name) {
            return userData.first_name;
          }
          if (userData.id) {
            return `User ${userData.id}`;
          }
        }
      } catch (parseError) {
        console.log('Ошибка при парсинге initData:', parseError);
      }
    }
  }

  // Если ничего не удалось получить
  return 'Anonym';
};
